import { render, staticRenderFns } from "./MyTextOne.vue?vue&type=template&id=d7df5e66&scoped=true"
import script from "./MyTextOne.vue?vue&type=script&lang=js"
export * from "./MyTextOne.vue?vue&type=script&lang=js"
import style0 from "./MyTextOne.vue?vue&type=style&index=0&id=d7df5e66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7df5e66",
  null
  
)

export default component.exports